import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { useLogout } from '@/modules/auth/components';
import { useIsAdmin } from '@/modules/auth/hooks';
import { useChat } from '@/modules/chat/hooks';
import { Button, Icon } from '@/modules/ui';

import { SubscriptionType } from '../../../constants';
import { SubscriptionAlertModal } from '../SubscriptionAlertModal';
import * as felaRules from '../SubscriptionFirewall.rules';

export const NotLinkedAlert = () => {
    const { css } = useFela();
    const isAdmin = useIsAdmin();
    const { show: showChat } = useChat();
    const logout = useLogout();

    const subscription = SubscriptionType['not-linked'];

    return (
        <SubscriptionAlertModal
            title={{ id: `settings.subscription.${subscription}.alert.title` }}
            text={{
                id: isAdmin ? `settings.subscription.${subscription}.alert.adminText` : `settings.subscription.${subscription}.alert.text`,
            }}
            endContent={
                <div>
                    <div className={css(felaRules.buttons)}>
                        {isAdmin && (
                            <Button
                                type='primary'
                                icon={<Icon type='chat' width='22' height='22' customStyle={felaRules.icon} />}
                                onClick={showChat}
                            >
                                <span>
                                    <FormattedMessage id={`settings.subscription.${subscription}.alert.chat`} />
                                </span>
                            </Button>
                        )}
                        <Button
                            icon={<Icon type='logout' width='16' height='16' customStyle={felaRules.icon} />}
                            loading={logout.isPending}
                            onClick={() => {
                                logout.mutate();
                            }}
                        >
                            <span>
                                <FormattedMessage id={`settings.subscription.${subscription}.alert.logout`} />
                            </span>
                        </Button>
                    </div>
                </div>
            }
        />
    );
};
